import { render, staticRenderFns } from "./CompanySafetyProfile.vue?vue&type=template&id=78733d86"
import script from "./CompanySafetyProfile.vue?vue&type=script&lang=js"
export * from "./CompanySafetyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports